import type { adminEn } from './admin-en.ts';

type DeepString<T> = T extends string ? string : { [K in keyof T]: DeepString<T[K]> };

/** Italian strings of the admin area. Typed against the English shape. */
export const adminIt: DeepString<typeof adminEn> = {
  admin: {
    title: 'Team',
    signedInAs: 'Accesso come {{role}}',
    roles: { moderator: 'moderatore', admin: 'amministratore' },
    gate: {
      loading: 'Controllo chi sei…',
      unavailable: 'L’area del team richiede un servizio account, che questa versione non ha.',
      signIn: 'Accedi con il tuo account del team per vedere questa pagina.',
      signInAction: 'Vai all’account',
      notStaff: 'Quest’area è per il team.',
      needsFactor:
        'Il team ha bisogno di un secondo fattore. Configura un’app di autenticazione e inserisci il suo codice in questa sessione.',
      needsFactorAction: 'Apri la sicurezza',
      adminOnly: 'Questa pagina è per gli amministratori.',
    },
    nav: { reports: 'Segnalazioni', players: 'Giocatori', live: 'Live', audit: 'Registro' },
    common: {
      reload: 'Ricarica',
      loading: 'Caricamento…',
      failed: 'Non ha funzionato. Riprova.',
      forbidden: 'Non puoi farlo.',
      saved: 'Salvato.',
      save: 'Salva',
      delete: 'Elimina',
      apply: 'Applica',
      noteLabel: 'Nota per l’archivio (facoltativa)',
      decision: 'Decisione',
    },
    decisions: {
      dismiss: 'Archivia: non c’è niente di male',
      warn: 'Richiamo',
      mute1: 'Silenzia la chat per 1 ora',
      mute24: 'Silenzia la chat per 24 ore',
      mute168: 'Silenzia la chat per 7 giorni',
      muteForever: 'Silenzia la chat finché non si toglie',
      ban24: 'Divieto per 24 ore',
      ban168: 'Divieto per 7 giorni',
      banForever: 'Divieto finché non si toglie',
    },
    outcome: {
      done: 'Fatto.',
      notFound: 'Non trovato: l’account potrebbe non esserci più.',
      alreadyResolved: 'Un altro ha già trattato questa segnalazione.',
    },
    reports: {
      title: 'Segnalazioni',
      status: { open: 'Aperte', actioned: 'Con provvedimento', dismissed: 'Archiviate' },
      empty: 'Nessuna segnalazione qui.',
      by: 'Segnalato da {{name}}',
      gone: 'un account che non c’è più',
      counts:
        'Segnalazioni aperte su questo giocatore: {{open}}. Sanzioni in archivio: {{actions}}.',
      heist: 'Colpo {{id}}',
    },
    players: {
      title: 'Giocatori',
      lookup: 'Soprannome e cifre',
      lookupHint: 'Come Ada#0042.',
      lookupAction: 'Cerca',
      notFound: 'Non c’è nessuno con quel nome.',
      since: 'Account dal {{date}}.',
      guest: 'Un ospite.',
      email: 'E-mail: {{email}}',
      matches: 'Colpi online: {{count}}.',
      reports: 'Segnalazioni contro di lui: {{open}} aperte, {{total}} in tutto.',
      history: 'In archivio',
      none: 'Niente in archivio.',
      kinds: { warn: 'Richiamo', mute: 'Chat silenziata', ban: 'Divieto' },
      inForce: 'in vigore',
      lifted: 'tolto',
      over: 'finito',
      until: 'fino al {{date}}',
      untilLifted: 'finché non si toglie',
      lift: 'Togli',
      act: 'Intervieni su questo giocatore',
    },
    live: {
      title: 'Live',
      flags: {
        title: 'Interruttori delle funzioni',
        enabled: 'Acceso',
        rollout: 'Quota di giocatori (%)',
      },
      config: {
        title: 'Configurazione remota',
        key: 'Chiave',
        value: 'Valore (JSON)',
        invalid: 'Non è un JSON valido.',
        add: 'Aggiungi o cambia',
        empty: 'Non c’è niente: l’app usa i suoi valori.',
      },
      news: {
        title: 'Novità',
        new: 'Nuova novità',
        edit: 'Modifica',
        titleIt: 'Titolo (italiano)',
        titleEn: 'Titolo (inglese)',
        bodyIt: 'Testo (italiano)',
        bodyEn: 'Testo (inglese)',
        publishedAt: 'Pubblicata',
        expiresAt: 'Scade (vuoto: mai)',
        pinned: 'In evidenza',
        draft: 'Non ancora uscita',
        expired: 'Scaduta',
        empty: 'Nessuna novità.',
        cancel: 'Annulla',
      },
    },
    audit: {
      title: 'Cosa ha fatto il team',
      empty: 'Ancora niente.',
      by: 'di {{name}}',
    },
  },
};
